import CTAButton from './CTAButton';

export * from './CTAButton';

export default CTAButton;
